import { read, utils } from 'xlsx';

export const USER_COLUMN_MAP = {
  'User Id': 'user_id',
  'Phone Number': 'phone_number',
  Amount: 'amount',
  'Reason of payment': 'reason_of_payment',
};

export const GROUP_COLUMN_MAP = {
  'Group Id': 'group_id',
  Amount: 'amount',
  'Reason of payment': 'reason_of_payment',
};

const NUMERIC_FIELDS = ['amount'];
const STRING_FIELDS = ['phone_number'];
const coerce = (key, value) => {
  if (NUMERIC_FIELDS.includes(key)) return Number(value);
  if (STRING_FIELDS.includes(key)) return String(value);
  return value;
};

const parseSpreadsheetFile = (file, columnMap) =>
  new Promise((resolve, reject) => {
    const supportedExtensions = ['csv', 'xlsx'];
    const format = (file.name || file.path || '').split('.').pop();

    if (!supportedExtensions.includes(format.toLowerCase())) {
      return reject(new Error(`Format not supported *.${format}`));
    }

    const expectedColumns = Object.keys(columnMap);

    const fileReader = new FileReader();
    fileReader.readAsBinaryString(file);
    fileReader.onload = event => {
      try {
        const workbook = read(event.target.result, {
          type: 'binary',
        });
        const sheet = workbook.SheetNames[0];
        const rows = utils.sheet_to_json(workbook.Sheets[sheet]);

        if (rows.length === 0) {
          return reject(new Error('The file is empty.'));
        }

        const fileColumns = Object.keys(rows[0]);
        const missing = expectedColumns.filter(
          col => !fileColumns.includes(col),
        );

        if (missing.length > 0) {
          return reject(
            new Error(`Missing columns: ${missing.join(', ')}`),
          );
        }

        const mapped = rows.map(row =>
          Object.entries(columnMap).reduce((acc, [label, key]) => {
            acc[key] = coerce(key, row[label]);
            return acc;
          }, {}),
        );

        resolve(mapped);
      } catch (err) {
        reject(
          new Error(
            'Could not read the file. Please upload the appropriate format.',
          ),
        );
      }
    };
    fileReader.onerror = () =>
      reject(new Error('Failed to read the file.'));
  });

export default parseSpreadsheetFile;
